module.exports = __webpack_public_path__ + "img/default-image.c7da139f.png";